<script>
    import 'firebase/auth';
    import "firebase/firestore";
    import { getContext } from 'svelte';

    import { userStore, page } from '../stores';

    import PageTitle from '../components/PageTitle.svelte';

    const auth = getContext('firebase').getFirebase().auth();
    const db = getContext('firebase').getFirebase().firestore();
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    let _organizationID = '';
    userStore.subscribe((a) => {
        if (!a) {
            return;
        }
        _organizationID = a.organizationID;
    });

    let email = '';
    let errorMessage = '';
    let messageSent = false;
    $: disabled = !Boolean(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email));

    function generateToken() {
        let retval = '';
        let milliseconds = Date.now().toString();

        for (let i = 0; i < milliseconds.length; i++) {
            retval += milliseconds.substring(i, i + 1);
            retval += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return retval;
    }

    async function sendInviteEmail() {
        if (disabled) {
            return;
        }

        let token = generateToken();
        await db.collection('inviteTokens').doc(token).set({
            organizationID: _organizationID,
            token: token,
            used: false,
        });
        
        await db.collection('mail').add({
            to: email,
            message: {
                subject: 'Campuspano Admin Account Invite',
                html: 'Click <a href="https://admin.campuspano.io/?p=create-account&t=' + token + '" >here</a> to create your account.<br><br>This link will expire in 48 hours.<br><br>Sent by <a href="https://campuspano.io/">Campuspano</a>',
            }
        });
        
        messageSent = true;
    }
</script>

<PageTitle text={'Invite User'} />
<div class='form-wrapper'>
    <form on:submit|preventDefault={sendInviteEmail}>
        <input bind:value={email} type='text' placeholder='Email'>
        {#if messageSent}
            <h5 class="black">Invited!</h5>
            <p class="black">It may take a few minutes to receive an email</p>
        {:else}
            <input type='submit' value='Send Invite' disabled={disabled}>
        {/if}
    </form>
    {#if errorMessage}
        <div class='form-error-message'>
            <span>{errorMessage}</span>
        </div>
    {/if}
</div>

<style>
    input[type=text] {
        width: 100%;
    }

    input[type=text] {
        margin: 0px 0px 10px 0px;
    }

    input[type=submit] {
        margin-top: 10px;
    }

    input[type=submit]:hover {
        cursor: pointer;
    }

    input[type=submit]:disabled {
        background-color: var(--grey);        
    }

    .black {
        margin-top: 10px;
        color: var(--off-black);
    }
</style>
